// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + "styles" + "." + "7179f865660cb2ad87cf" + ".bundle.css";
};